/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import { consumirServicioEncirptacion } from 'api';
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import Page from 'components/Page';
import TablaPolizas from 'components/Polizas/Administrador/TablaPolizas';
import { urlEmisionPoliza } from 'constants/urls';
import useCustomLocation from 'hooks/useCustomLocation';
import useUsuario from 'hooks/useUsuario';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginAsSuscriptor, logoutAsSuscriptor } from 'redux/actions/aLogin';
import Loading from 'wrappers/Loading';

const PATH_POLIZA = ['/listado-polizas', '/listado-polizas-certificados'];
const PATHS_CERTIFICADOS = ['/listado-polizas-certificados'];
const VIEW = {
  '/listado-polizas': {
    title: 'Listado de pólizas',
    subtitle: 'Listado de pólizas',
  },
  '/listado-pre-polizas': {
    title: 'Listado de pre pólizas',
    subtitle: 'Listado de pre pólizas',
  },
  '/listado-polizas-certificados': {
    title: 'Listado de pólizas',
    subtitle: 'Listado de pólizas',
  },
};

const ContainerListadoPolizas = ({ history }) => {
  const [data, setData] = useState([]);
  const [diccionario, setDiccionario] = useState([]);
  const usuario = useUsuario();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const location = useCustomLocation();

  const { cliCodigoCore, correo, usu_tipo_usuario } = useSelector(
    (state) => state.datosUsuarios.dataUsuario,
  );

  const init = async () => {
    setLoading(true);

    setData([]);

    const Data = {
      datosCotizador: {
        ambiente: 'desarrollo',
        cotPasoCodigo: 'obtenerPolizasUsuario',
        usuCodigo: cliCodigoCore,
        isPolizaCompleta: isPoliza(),
        getSoloCertificados: getCertificados(),
        rol: usuario?.usu_tipo_usuario
      },
    };

    if (usu_tipo_usuario === 'cliente') {
      Data.datosCotizador.usuCodigo = correo;
    }

    if (usuario?.isSuscriptor && usuario?.usu_tipo_usuario !== 'usu-suscriptor-sbs') {
      if (usuario?.sesionSuscriptor) {
        const { sesionSuscriptor } = usuario;
        Data.datosCotizador.usuCodigo = sesionSuscriptor?.cliCodigoCore
        dispatch(loginAsSuscriptor(sesionSuscriptor))
      } else {
        if (usuario?.usu_tipo_usuario !== "usu-suscriptor-casualty-contratistas" && usuario?.usu_tipo_usuario !== "usu-suscriptor-casualty-generales") {
          dispatch(logoutAsSuscriptor());
          return history.push("/");
        }
      }
    }

    console.log('DATA: ', Data);
    const json = await consumirServicioEncirptacion(urlEmisionPoliza, Data);
    console.log(json);
    if (json.transaccion && json.catalogo && json.catalogo.arraycompras) {
      console.log(json.catalogo);
      setData(json.catalogo.arraycompras);
      setDiccionario(json.catalogo.diccionarioTabla);
    }

    setLoading(false);
  };

  const isPoliza = useCallback(() => PATH_POLIZA.includes(location.pathname), [
    location.pathname,
  ]);

  const getCertificados = useCallback(
    () => PATHS_CERTIFICADOS.includes(location.pathname),
    [location.pathname],
  );

  useEffect(() => {
    init();
  }, [location.pathname]);

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <Breadcrumcomponent {...VIEW[location.pathname]} />

          <div className="row justify-content-center">
            <div className="col-12">
              <TablaPolizas data={data} diccionario={diccionario} />
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default ContainerListadoPolizas;
